import * as jose from 'jose'
import {
  JITSI_SECRET_KEY,
  statusEntered,
  statusNotEntered,
  sucessErrorMsg,
} from './constants'
import { startSxpProxy } from '../utils/api'
import {
  archiveAppointmentApi,
  CHAT_PROJECT_ID,
  deleteAppointmentApi,
} from '../utils/constants'
import { getAppointmentsBySlotAndDate } from '../features/appointments/models'
import KeycloakService from '../utils/keycloakService'
import axios from 'axios'
import { dropDownMenuKeys } from '../components/constants'
interface GetAppointmentsParams {
  startDate: Date
  locationId: string
  limit?: number
  offset?: number
  searchParam?: string
  status: string
  speciality?: string
}
export async function decodeJwe(key: string) {
  let jweToken = ''
  const secretKey = new TextEncoder().encode(JITSI_SECRET_KEY)

  try {
    const { plaintext } = await jose.compactDecrypt(key, secretKey)
    jweToken = new TextDecoder().decode(plaintext)
  } catch (error) {
    console.error(error)
  }
  return jweToken
}

export async function fetchJitsiToken(): Promise<string> {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_GATEWAY_URL}${process.env.REACT_APP_JITSI_TOKEN_ENDPOINT}`
    )
    if (!response.ok) {
      throw new Error(sucessErrorMsg?.tokenFetchError)
    }
    const key = await response.text()
    if (!key) {
      console.error(sucessErrorMsg?.noKeyReturned)
      return ''
    }
    const jwtToken = await decodeJwe(key)
    return jwtToken
  } catch (error) {
    console.error(error)
    return ''
  }
}

export const getAppointmentsBySlotAndDateService = async ({
  startDate,
  locationId,
  limit = 100,
  offset = 0,
  status,
  speciality,
}: GetAppointmentsParams) => {
  try {
    const response = await startSxpProxy(
      CHAT_PROJECT_ID,
      getAppointmentsBySlotAndDate,
      {
        startDate: startDate.toISOString().slice(0, 10),
        locationId,
        limit,
        offset,
        status,
        ...(speciality ? { speciality } : {}),
      }
    )

    return response?.data
  } catch (error) {
    console.error('Error fetching appointments:', error)
    throw error
  }
}
export const deleteAppointment = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_GATEWAY_URL}${deleteAppointmentApi}${data}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const ArchiveAppointment = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${archiveAppointmentApi}${data}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const getAppointments = async (
  selectedLocation: any,
  searchValue: any,
  startDate: any,
  page: any,
  pageSize: any,
  status: string,
  speciality?: string
) => {
  const statusParam =
    status === dropDownMenuKeys?.active ? statusNotEntered : statusEntered
  try {
    const dateObj = new Date(startDate)?.toISOString()?.split('T')?.[0]
    const token = KeycloakService?.getToken()
    const specialityParam = speciality
      ? `&specialty=${encodeURIComponent(speciality)}`
      : ''
    const url = `${process.env.REACT_APP_MEDUNITED_AWGMENT_GATEWAY}/fhir/Appointment?slot.schedule.actor:Location=${selectedLocation}&slot.start=${dateObj}&patient.${searchValue?.type}=${searchValue?.value}${specialityParam}&_include=Appointment:slot&_include=Appointment:actor&_include:iterate=Slot:schedule&_include:iterate=Schedule:actor&_revinclude=Encounter:appointment&_count=${pageSize}&_getpagesoffset=${page}&${statusParam}`
    const data = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
    if (data?.data?.entry && data?.data?.entry?.length > 0) {
      return {
        data: data?.data,
        success: true,
        message: 'Fetched Appointments Successfully',
      }
    } else {
      return {
        data: null,
        success: false,
        message: 'No Data Found',
      }
    }
  } catch {
    return {
      data: null,
      success: false,
      message: 'An Error Occured',
    }
  }
}
